import { useEffect } from 'react';
export function usePromptOnLeave(cb) {
    useEffect(() => {
        const handler = (event) => {
            const message = cb(event);
            if (message) {
                event.returnValue = message;
            }
        };
        window.addEventListener('beforeunload', handler);
        return () => {
            window.removeEventListener('beforeunload', handler);
        };
    }, [cb]);
}
